export default __webpack_public_path__ + "static/media/video15.5bd5942e.webp";